// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3hCQC","range":"MonthRangeSwitch_range__1oYXh","disabled":"MonthRangeSwitch_disabled__1h4VK"};